






































import moment from "moment";
import { Component, Vue } from "vue-property-decorator";
@Component({ name: "help-bot-component" })
export default class MaintenaceComponent extends Vue {
  get active(): boolean {
    return this.$store.getters["SystemStore/getMaintenanceModal"];
  }
  set active(e) {
    this.$store.dispatch("SystemStore/setMaintenanceModalAction", e);
  }
  get start(): string {
    const maintenanceStart =
      this.$store.getters["SystemStore/getMaintenanceStart"];
    return moment
      .utc(moment(parseInt(maintenanceStart) * 1000))
      .local()
      .format("h:mm a");
  }
  get finish(): string {
    const maintenanceFinish =
      this.$store.getters["SystemStore/getMaintenaceFinish"];
    return moment
      .utc(moment(parseInt(maintenanceFinish) * 1000))
      .local()
      .format("h:mm a");
  }
  get isMessageError(): boolean {
    const maintenanceMessageError =
      this.$store.getters["SystemStore/getMaintenanceMessageError"];
    return maintenanceMessageError;
  }
  async reload() {
    this.active = false;
    window.location.reload();
  }
}
